import React from "react";

const NoSearch = () => {
  return (
    <div>
      <div className="no-search bg-no_data"></div>
      <h3>No active search</h3>
    </div>
  );
};

export default NoSearch;
